enum CalendarEventOmission {
    /**
     * Event sharing from calendar
     */
    None,

    /**
     * Event sharing from mail
     */
    Unexpected,

    /**
     * Email reminder
     */
    Configuration,

    /**
     * Event omitted because the trust score of the entity is under the acceptable threshold
     */
    Trust,

    /**
     * Event omitted because an error occurred when trying to create it
     */
    Error,

    /**
     * Event omitted because we are not supposed to create it, i.e. a flight cancellation
     */
    ByDesign,

    /**
     * Event omitted because it was in the past
     */
    InThePast,

    /**
     * Event omitted because it was shared by another user
     */
    SharedEvent,
}

export default CalendarEventOmission;
